var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('my-head',{scopedSlots:_vm._u([{key:"middle",fn:function(){return [_vm._v(" 最近浏览 ")]},proxy:true}])}),(_vm.data)?_c('goods-card',{attrs:{"data":_vm.data,"boolean":_vm.boolean}}):_c('div',{staticClass:"t-a-c p-10"},[_vm._v("暂无记录")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }